import { useEffect } from 'react';

export function useGenericEffect(callback, deps = []) 
{  useEffect(() => 
    {    
      callback();    
         
     //load initial state
       const loadElement = document.getElementById("loadstate");
        if (loadElement) {
           const loadId = loadElement.innerText;
           const menuElement =  document.getElementById(loadId); 
           menuElement.classList.add('selected');    
        }
    
       // Generic function to handle mouseover    
       const handleMouseClick = (event) => {    
          resetAllMenuItems(document.getElementById('content-container-menu').children);
          loadElement.innerText = event.target.id; 
          event.target.classList.add('selected');    
       };   
      const resetAllMenuItems = (children) => {
            for (const div of children) 
            {  
              if (div.tagName === 'DIV') 
              {    
                div.classList.remove('selected') ;  
              }
            }
       }


      
       // Attach listeners to all divs that match the pattern  
       const divs  = document.querySelector('#content-container-menu').querySelectorAll('div[id]');    
       divs.forEach((div) => {      
        if (div.id !== 'content-container-main') {       
           div.addEventListener('click', handleMouseClick);         
          }    
        });    
        // Cleanup on unmount    
        return () => {     
          divs.forEach((div) => {        
            div.removeEventListener('click', handleMouseClick);          
          });    
        };    
 }, deps);}